
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 4.64a6.652 6.652 0 014.64 1.786l3.387-3.31A11.53 11.53 0 0012 0 11.993 11.993 0 001.28 6.613l3.88 3.012A7.252 7.252 0 0112 4.64z","fill":"#E43E2B"}}),_c('path',{attrs:{"d":"M23.52 12.265a10.274 10.274 0 00-.254-2.452H12v4.452h6.614a5.862 5.862 0 01-2.454 3.893l3.787 2.932a11.73 11.73 0 003.577-8.825h-.004z","fill":"#3B7DED"}}),_c('path',{attrs:{"d":"M5.174 14.37a7.382 7.382 0 01-.4-2.372 7.76 7.76 0 01.386-2.373L1.28 6.613a11.97 11.97 0 000 10.77l3.894-3.012z","fill":"#F0B501"}}),_c('path',{attrs:{"d":"M12 23.995a11.438 11.438 0 007.947-2.905l-3.787-2.933a7.104 7.104 0 01-4.16 1.2 7.225 7.225 0 01-6.826-4.986l-3.88 3.013A11.97 11.97 0 0012 23.995z","fill":"#2BA24C"}})])
          )
        }
      }
    